import Contact from "../components/Contact";
import Footer from "../components/Footer";
import Usage from "../components/Usage";
import TrainingVideo from "../components/TrainingVideo";
import Navigation from "../components/Navigation";
import HeaderImage from "../components/HeaderImage";
import New from "../components/New";
import styled from "styled-components";
import {GiEcology} from "react-icons/gi";
import {ImSun} from "react-icons/im";
import {RiTimeZoneFill} from "react-icons/ri";

const Wrapper = styled.div`
    font-family: "Roboto", "serif";
    width: 100%;
    background-color: white;
    overflow: hidden;
`;

const IconsWrapper = styled.div`
    font-family: "Roboto", "serif";
    width: 100%;
    text-align: center;
    font-size: 100px;

`;

function Main() {
    return (
    <Wrapper>
        {/*<Navigation/>*/}
        {/*<HeaderImage/>*/}
        {/*<TrainingVideo/>*/}

        {/*<IconsWrapper>*/}
        {/*    <GiEcology />*/}
        {/*    <ImSun />*/}
        {/*    <RiTimeZoneFill />*/}
        {/*</IconsWrapper>*/}

        {/*<Usage/>*/}
        {/*<Contact/>*/}
        {/*<Footer/>*/}
        <New />
    </Wrapper>
);
}

export default Main;
